import React from "react";
import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

export default function PageHeader() {
  return (
    <PageHeaderContainer component="header">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: { xxs: "10px", xs: "30px" },
          ml: { xxs: "10px", xs: "20px" },
          height: "50px",
        }}
      >
        <img
          src="/DataIQ_logo_2025_whitered_RGB.png"
          alt="logo"
          height="100%"
          width="100%"
          style={{ objectFit: "contain" }}
        />
      </Box>
      <PageHeaderTitle sx={{ color: "white", mr: { xxs: "10px", xs: "30px" } }}>
        <Typography component="h1" variant="h4" align="right">
          Data Capability Matrix
        </Typography>
      </PageHeaderTitle>
    </PageHeaderContainer>
  );
}

const PageHeaderContainer = styled(Box)`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  background: rgb(41, 46, 74);
  background: linear-gradient(
    90deg,
    rgba(41, 46, 74, 1) 0%,
    rgba(41, 46, 74, 1) 9%,
    rgba(28, 46, 106, 1) 100%
  );
`;

const PageHeaderTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  margin-right: 30px;
  border-right: 2px solid #f25764;
  max-width: 50%;
`;
